import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import type { MetricListItem } from '../chartTypes.ts';
import { HOUSEHOLD_PROFILE_BUCKETS } from '../constants.ts';
import { parseMetricList } from './utils.ts';

export const parseHouseholdProfile = (response: HouseholdInsightsApiResponse | undefined): MetricListItem[] =>
  parseMetricList(response?.household_profile, HOUSEHOLD_PROFILE_BUCKETS);
